import { type IAppState } from "./app.interface";

export const appState: IAppState = {
  loading: false,
  serverError: false,
  forbiddenError: false,
  clientErrors: {},
  clientMessages: {},
};
